// Notifications plugin. Used on Notifications page
import Notifications from "src/components/UI/NotificationPlugin";
// Validation plugin used to validate forms
import VeeValidate from "vee-validate";
// A plugin file where you could register global components used across the app
import SideBar from "src/components/UI/SidebarPlugin";

// element ui language configuration
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";

import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";

// asset imports
import "src/assets/css/nucleo-icons.css";
import "src/assets/sass/black-dashboard-pro.scss";

locale.use(lang);

export default {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(GlobalDirectives);
        Vue.use(SideBar);
        Vue.use(Notifications, {
            verticalAlign: "top",
            horizontalAlign: "center",
            showClose: false,
            timeout: 5000,
        });
        Vue.use(VeeValidate, { fieldsBagName: "veeFields" });
    },
};
